import styled from '@emotion/styled';
import { Text, H3 } from 'ds/components/typography';
import { Button } from 'ds/components/button';

export const Root = styled.div(({ theme }) => ({
  padding: theme.spacing(4, 3),
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${theme.colors.neutrals.grey6}`,
  backgroundColor: theme.colors.brand.lightBlue,
  display: 'flex',
  gap: theme.spacing(3),
  flexDirection: 'column',
  boxShadow: theme.shadow.level8,
}));

export const FormTitle = styled(H3.withComponent('div'))(({ theme }) => ({
  textAlign: 'center',
  color: theme.colors.neutrals.grey1,
}));

export const InfoBox = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 3),
  borderRadius: theme.borderRadius.small,
  backgroundColor: theme.colors.neutrals.white,
  gap: theme.spacing(1.5),
}));

export const FormBody = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  'a': {
    flexGrow: 1,
  },
  'button': {
    flexGrow: 1,
    'svg': {
      display: 'block',
    },
  },
}));

export const UserName = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const PhoneButton = styled(Button.withComponent('a'))(({ theme }) => ({
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  svg: {
    marginLeft: theme.spacing(1),
  },
}));
